import { useContext } from 'react';
import { HouseHoldVisitChartsDataContext } from '../contexts/HouseHoldVisitChartsDataContext';

export const useHouseHoldVisitChartsDataContext = () => {
    return useContext(HouseHoldVisitChartsDataContext);
};
